<template>
  <div class="self-stretch flex flex-col justify-start items-center gap-8">
    <!-- Title -->
    <div class="self-stretch flex flex-col gap-6">
      <div class="flex justify-between items-center">
        <div class="text-white text-2xl font-bold capitalize">
          {{ $t('people') }}
        </div>
      </div>

      <!-- Content -->
      <div class="flex flex-col gap-4">
        <div class="text-white text-[16px] font-medium">
          {{ participants_number }}/{{ participants_limit }}
          {{ $t('participants') }}
        </div>

        <SwitchGroup as="div" class="flex justify-between items-center" v-if="canMute">
          <span class="flex flex-col">
            <SwitchLabel class="text-sm font-medium text-white">
              {{ $t('audience_participation') }}
            </SwitchLabel>
            <SwitchDescription class="text-xs text-white opacity-75 max-w-72 mt-1">
              {{ $t('audience_participation_desc') }}
            </SwitchDescription>
          </span>

          <!-- SWITCH -->
          <Switch
              :model-value="participation_enabled"
              @update:modelValue="onToggle"
              :disabled="!canMute"
              :class="[
              participation_enabled ? 'bg-primary' : 'bg-gray-700',
              'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-600 focus:ring-offset-2'
            ]"
          >
            <span
                aria-hidden="true"
                :class="[
                participation_enabled ? 'translate-x-5' : 'translate-x-0',
                'pointer-events-none inline-block size-5 transform rounded-full bg-white shadow transition duration-200 ease-in-out'
              ]"
            />
          </Switch>
        </SwitchGroup>

        <div v-else class="w-[300px]">
          <div class="flex flex-col">
            <div>
              <span class="ui-indicator w-3 h-3 rounded-full  inline-flex mr-[6px]" :class="[participation_enabled ? 'bg-primary' : 'bg-elements-red']"></span>
              <span class="text-text-neutral-extreme text-sm">{{ participation_enabled ? $t('participation_enabled') : $t('participation_disabled') }}</span>
            </div>
            <div class="text-text-neutral-medium text-xs mt-1 inline-flex">
              {{ participation_enabled ? $t('participation_enabled_msg_for_guests') : $t('participation_disabled_msg_for_guests') }}
            </div>
          </div>
        </div>

        <div class="mt-4">
          <session-info :room_code="event.room_code"></session-info>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  Switch,
  SwitchGroup,
  SwitchLabel,
  SwitchDescription
} from '@headlessui/vue'
import SessionInfo from "@/components/session/SessionInfoLegacy.vue";

export default {
  name: 'HostControlsLegacy',

  components: {
    SessionInfo,
    Switch,
    SwitchGroup,
    SwitchLabel,
    SwitchDescription
  },

  props: {
    participants_number: {
      type: Number,
      default: 0
    },
    participants_limit: {
      type: Number,
      required: true
    },
    userRole: {
      type: String,
      default: 'regular'
    },
    participation_enabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('event', ['event']),

    canMute() {
      return this.userRole === 'sponsor' || this.userRole === 'host'
    }
  },

  methods: {
    onToggle(val) {
      this.$emit('commit', val)
    }
  }
}
</script>
